// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination_wrapper__bQpBE","arrowRight":"Pagination_arrowRight__hogSP","arrowLeft":"Pagination_arrowLeft__ZXIiN"};